module.exports = __webpack_public_path__ + "static/img/COC2021-9.8570f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-9.jpg
// module id = H8Tc
// module chunks = 0